import { useMemo } from 'react';
import { twMerge } from 'tailwind-merge';

export default function SkeletonSlider() {
  const random = useMemo(() => Math.random() > 0.5, []);

  return (
    <div className="w-full">
      <div className="flex items-center justify-between w-full mb-5">
        <div className="animate-pulse bg-background-accent h-7 w-24" />
        <div className="animate-pulse bg-background-accent h-9 w-28" />
      </div>
      <div className="relative mb-4">
        <div className="animate-pulse bg-background-accent w-full h-1" />
        <div
          className={twMerge(
            'animate-pulse bg-background-accent h-9 w-9 absolute left-1/3 rounded-full top-0 -translate-y-4',
            random && 'left-2/3',
          )}
        />
      </div>
      <div className="flex items-center justify-between w-full">
        <div className="animate-pulse bg-background-accent h-3 w-12" />
        <div className="animate-pulse bg-background-accent h-3 w-14" />
      </div>
    </div>
  );
}
